import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import { loadFonts } from './plugins/webfontloader'

let apiWebsite = axios.create({
    baseURL: process.env.VUE_APP_API_WebSite,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

let apiAuth = axios.create({
    baseURL: process.env.VUE_APP_API_AUTH,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

loadFonts()

const app = createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)

app.config.globalProperties.$apiWebsite = apiWebsite
app.config.globalProperties.$apiAuth = apiAuth

app.mount('#app')
